/**
 * # Modulo
 * Float safe modulo call. Based off just-modulo, but made float safe. Math with floats can have unexpected results in JS
 *
 * @param {Function} func
 * @param {Integer} delay
 *
 * @see http://www.codeavenger.com/2017/05/19/JavaScript-Modulo-operation-and-the-Caesar-Cipher.html
 * @see https://github.com/angus-c/just#just-modulo
 */

function modulo(val, step) {
  val = Number(val);
  step = Number(step);

  // step needs to be > 0
  if (step <= 0) {
    return NaN;
  }
  const valDecCount = (val.toString().split('.')[1] || '').length;
  const stepDecCount = (step.toString().split('.')[1] || '').length;
  const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
  const valInt = parseInt(val.toFixed(decCount).replace('.', ''));
  const stepInt = parseInt(step.toFixed(decCount).replace('.', ''));

  return (valInt % stepInt + stepInt) % stepInt / Math.pow(10, decCount);
}

export default modulo;
